import { IManagableObject } from "./IManagableObject";
import { ContainerUserLink } from "app/models/ContainerUserLink";

export class ContainerViewModel implements IManagableObject {
  Id: number = 0;
  CompanyId: number = 0;
  Name: string;
  CanSelect?: boolean;
  Users?: ContainerUserLink[];

  private normalizeUsers(users: any[] | undefined): ContainerUserLink[] {
    if (!Array.isArray(users)) return [];

    return users.map(user => ({
      UserId: user?.UserId ?? user?.userId ?? 0,
      ACL: user?.ACL ?? user?.acl ?? 0
    }));
  }

  init(data?: any) {
    if (data) {
      this.Id = data["id"];
      this.CompanyId = data["companyId"];
      this.Name = data["name"];
      this.CanSelect = data["canSelect"];
      this.Users = this.normalizeUsers(data["users"]);
    }
  }

  static fromJS(data: any): ContainerViewModel {
    data = typeof data === "object" ? data : {};
    const result = new ContainerViewModel();
    result.init(data);
    return result;
  }

  IsChecked: boolean;
}
